import {
    initJump,
    // jump,
    // LazyLoad,
    SmoothScroll,
    // post,
    // postFormData,
    // youtubeVideo,
    // createUniqueHash,
    // addIntersectionItem,
    // setCookie,
    // getCookie,
    // isScrollingDown,
    waitAnimationFrame,
    // easeInOutQuad,
    // easeOutQuad,
    // animationEnd,
    // transitionEnd,
    ProgressiveHover,
    setViewUnits,
    createCounters
} from './02-tools'
import { ScrollAnim, SetupVideos, SetupAutoPlayVideos, ReadMore, PageList } from './06-utilities'
import {
    Selects, // dynamic import
    FormInit, // dynamic import
    // HoverLabelInit, // dynamic import
    AccordionsInit, // dynamic import
    Map, // dynamic import
    // modalController,
    Modals, // dynamic import
    SliderInit, // dynamic import,
    SetupTabs, // dynamic import
    Toggle,
    Nav,
    GlobalNotification,
    ServiceUpdates,
    HoverItems,
    StatRing,
    setupWizard, // dynamic import
    TrackForm, // dynamic import of form controller
    StickyBtn,
    Clipboard,
    SearchDirectory,
    SpotlerForms,
    RFHeader,
    RfTrack
} from './07-components'

// import { listen } from 'quicklink'
import lazySizes from 'lazysizes'
import 'wicg-inert'

export function init() {
    document.body.classList.remove('preload')
    document.body.classList.add('loaded') // trigger css to know js has loaded
    setViewUnits()

    // wait for style update from .loaded class
    waitAnimationFrame(() => {
        AccordionsInit()
        initJump()
        SliderInit()
        Modals()
        FormInit()
        SetupTabs()
        Selects()
        PageList()
        Map()
        SetupVideos()
        SetupAutoPlayVideos()
        ScrollAnim(['.u-scroll-anim'])
        SmoothScroll()
        ReadMore()
        Toggle()
        RFHeader()
        Nav()
        GlobalNotification()
        ServiceUpdates()
        setupWizard()
        HoverItems()
        StatRing()
        TrackForm()
        StickyBtn()
        ProgressiveHover()
        Clipboard()
        SearchDirectory()
        SpotlerForms()
        createCounters()
        RfTrack()

        // if (!window.isLoggedIn) {
        //     listen()
        // }
        if (typeof lazySizes === 'function') {
            lazySizes()
        }
    })
}

if (!(typeof process !== 'undefined' && process.env.STORYBOOK)) {
    if (document.readyState !== 'loading') {
        init()
    } else {
        document.addEventListener('DOMContentLoaded', init)
    }
}

console.log('awe')
$('form').on('submit', function () {
    console.log('test')
    if (typeof CKEDITOR !== 'undefined') {
        for (var instance in CKEDITOR.instances) {
            CKEDITOR.instances[instance].destroy(true)
        }
    }
})
